











import Vue from 'vue';
import AudienceForm from '@/components/audience/AudienceForm.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'UpdateAudience',
  components: { AudienceForm },
  props: {
    id: {
      required: true,
    },
  },
  async mounted() {
    this.loadData = true;
    await Promise.all([
      this.$store.commit('changeTitle', this.$t('sidebar.full.audience')),
      this.$store.dispatch('audience/audience', {
        id: this.id,
        expand: 'pixels',
        fields:
          'name,segmentation,only_involved,site_time_id,from_date,to_date,pixel_id',
      }),
      this.$store.dispatch('audience/getPixels'),
      this.$store.dispatch('audience/siteTimes'),
    ]);
    this.loadData = false;
  },
  computed: {
    ...mapGetters({
      pixels: 'audience/getPixels',
      siteTimes: 'audience/getSiteTimes',
    }),
  },
  methods: {
    updateAudience() {
      this.$store.dispatch('audience/submitForm', {
        id: this.id,
        APIName: 'updateAudience',
        backUrl: this.backUrl,
      });
    },
    setBackUrl(url) {
      if (url) {
        this.backUrl = url;
      }
    },
  },
  data() {
    return {
      loadData: false,
      backUrl: null,
    };
  },
});
